import { Component, Input, OnInit } from '@angular/core';
import { CustomerStatModel } from '@admin/stats-and-reports/shared/models/customer-stat-model';

@Component({
  selector: 'hr-stats-and-reports-customers',
  templateUrl: './stats-and-reports-customers.component.html',
  styleUrls: ['./stats-and-reports-customers.component.less'],
  standalone: false,
})
export class StatsAndReportsCustomersComponent implements OnInit {
  @Input()
  public customerStats: CustomerStatModel;
  constructor() {}

  ngOnInit() {}
}
